import {testProject} from './testProject.js'

export const availableProjects = [
  {
    projectName: 'Test Project',
    projectId: '001-A',
    createdOn: '2019-01-23T19:00Z',
    lastModified:'2019-01-24T19:00Z',
    folder: 1,
    data: null
  },
  {
    projectName: 'Another Project',
    projectId: '001-B',
    createdOn: '2019-01-23T19:00Z',
    lastModified: '2019-01-25T19:00Z',
    folder: 2,
    data: null
  }
];